import styled from "styled-components"
import { useAuthorisedValuesCategory } from "../../controllers/AuthorisedValuesCategoryController";
import { useAuthorisedValues } from '../../controllers/AuthorisedValuesController'
import { Row, Col, Button, setParamsFilter, Typography, Modal } from '../../../ui/ot'
import { useState, useRef, useEffect } from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../../../ui/select"
import { useParams, useNavigate } from 'react-router-dom'
import ProTableOt from "./../../../utility/componentOt/views/ProtableOt"
import { useProTableOt } from '../../../utility/componentOt/controllers/ProtableOtController'
import { useTranslation } from "react-i18next";

const AuthorisedValuesCategory = ({
    title,
    keyPrefix = 'library.backstage.authorized_values_management'
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const thisJS = "AuthorisedValuesCategoryDetail"
    const { category } = useParams()
    const navigate = useNavigate()
    const actionRef = useRef()
    const dataRef = useRef(category)
    const [modal, setModal] = useState({
        open: false,
        title: '',
        body: '',
        onOK: {},
        footer: null
    });

    const columns = [
        {
            title: t('authorised_value'),
            dataIndex: 'authorised_value', key: 'authorised_value',
            sorter: true,
            render: (text, record, index) => {
                return <>
                    <Typography.P>{record?.authorised_value}</Typography.P>
                </>
            }
        },
        {
            title: t('description'),
            dataIndex: 'description', key: 'description',
            sorter: true,
            ellipsis: true,
            render: (text, record, index) => {
                return <>
                    <Typography.P>{record?.description}</Typography.P>
                </>
            }
        },
        {
            title: t('description_opac'),
            dataIndex: 'description_opac', key: 'description_opac',
            sorter: true,
            ellipsis: true,
            render: (text, record, index) => {
                return <>
                    <Typography.P>{record?.description_opac}</Typography.P>
                </>
            }
        },
        {
            title: t('library_information'),
            dataIndex: 'branches', key: 'branches',
            render: (text, record, index) => {
                return <FlexBox>
                    {
                        (record?.branches || []).map((value, index) => {
                            return <Library key={value.branchcode}>{value.branchname}</Library>
                        })
                    }
                </FlexBox>
            }
        },
        {
            title: '',
            key: 'option', valueType: 'option',
            render: (text, record, index) => {
                return <>
                    <Typography.P>
                        <Button variant="ghost" onClick={() => { navigate(`/library/backstage/authorized_values_management/${dataRef.current}/${record?.id}`) }}>{t('edit')}</Button>
                        <Button variant="ghost" onClick={() => { showDeleteModal(record?.id) } }>{t('delete')}</Button>
                    </Typography.P>
                </>
            }
        }
    ]
    const showDeleteModal = (id) => {
        setModal({
            open: true,
            title: '系統訊息',
            body: <h5>確定要刪除此項目？</h5>,
            footer: <Row className='d-flex justify-content-end'>
                <Button className='mx-2' onClick={() => { handleDeleteModalConfirm(id) }}>{t('delete')}</Button>
                <Button onClick={() => { handleDeleteModalConfirm(0) }}>{t('cancel')}</Button>
            </Row>
        })
    }
    const handleDeleteModalConfirm = (id) => {
        if (id > 0) { deleteAuthorisedValuesData([{ id }]) }
        setModal({ ...modal, open: false })
    }
    const {
        AuthorisedValuesCategoryData,
        getAuthorisedValuesCategoryData,
    } = useAuthorisedValuesCategory({
        onBefore: ({ axiosMode, values }) => {
            //console.log(thisJS, "AuthorisedValuesCategoryData", axiosMode, "onBefore", values)
        },
        onFinish: ({ axiosMode, status, values }) => {
            //console.log(thisJS, "AuthorisedValuesCategoryData", axiosMode, "onFinish", status, values)
        }
    })
    useEffect(() => {
        getAuthorisedValuesCategoryData({
            size: 999
        })
            .then((response) => {
                //let datas = response?.data
                //console.log(thisJS, "AuthorisedValuesCategoryData", "get", "useEffect", datas)
            })
    }, [])
    //useEffect(() => {
    //    if (paramsIn.category === stateData.category) { return }
    //    setStateData({ ...stateData, category: paramsIn.category })
    //    actionRef.current.reload({ params: stateData })
    //}, [paramsIn.category, stateData])

    const {
        getAuthorisedValuesData,
        deleteAuthorisedValuesData,
    } = useAuthorisedValues({
        onBefore: ({ axiosMode, values }) => {
            console.log(thisJS, "AuthorisedValuesData", axiosMode, "onBefore", values)
        },
        onFinish: ({ axiosMode, status, values }) => {
            //console.log(thisJS, "AuthorisedValuesData", axiosMode, "onFinish", status, values)
            if (axiosMode === "delete") {
				actionRef.current.reload()
			}
        }
    })
    const {
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns
    })
    return (
        <>
            <Row>
                <Col span={24}>
                    <Title>
                        {t('authorised_value')}
                    </Title>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Title>{t('show_category')}:</Title>
                </Col>
                <Col>
                    <Select
                        onValueChange={(e) => {
                            dataRef.current = e
                            actionRef.current.reloadAndRest()
                        }}
                        defaultValue={dataRef.current} value={dataRef.current}>
                        <SelectTrigger>
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            {
                                (AuthorisedValuesCategoryData || []).map((value) => {
                                    return (
                                        <SelectItem key={value.category} value={value.category}><span>{value?.category}</span></SelectItem>
                                    )
                                })
                            }
                        </SelectContent>
                    </Select>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <ProTableOt
                        actionRef={actionRef}
                        columns={columns}
                        rowSelection={{}}
                        
                        request={async (params, sort, filter) => {
                            console.log(thisJS, "ProTableOt", "request", params, sort, filter)
                            return getAuthorisedValuesData({
                                ...params, category: dataRef.current
                            })
                        }}
                        options={{}}
                        toolBarRender={() => {
                            return ([
                                <Button variant="outline"
                                    onClick={() => {
                                        navigate(`/library/backstage/authorized_values_management/New`)
                                    }}>{t('new_category')}</Button>,
                                <Button variant="outline"
                                    onClick={() => {
                                        navigate(`/library/backstage/authorized_values_management/${dataRef.current}/New`)
                                    }}>{t('add')}{dataRef.current}{t('authorized_values')}</Button>,
                            ])
                        }}
                    />
                </Col>
            </Row>
            <Modal
                open={modal.open}
                title={modal.title}
                onOk={modal.onOk}
                footer={modal.footer}
            >
                {modal.body}
            </Modal>
        </>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: center;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`
const FlexBox = styled.div`
display: flex;
gap: 1em;
`
const Library = styled.div`
magin-left: 0.5em;
magin-right: 0.5em;
`

export default AuthorisedValuesCategory